import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'requestOnlyFilter'
})
export class RequestOnlyFilterPipe implements PipeTransform {

  transform(items: any[], filter: Object): any {

        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.request_only == filter);

    }

}
